import "./App.css";
import { Layouts } from "./layouts/Layouts";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Calendar from "./pages/Calendar";
import History from "./pages/History";
import Profile from "./pages/Profile";
import Queries from "./pages/Queries";
import VisitingCard from "./pages/VisitingCard";
import Settings from "./pages/Settings";
import BadgeList from "./pages/BadgeList";
import Chat from "./pages/Chat";
import CollectedVisitingCard from "./pages/CollectedVisitingCard";
import Configuration from "./pages/Configuration";
import ExitSession from "./pages/ExitSession";
import LiveSession from "./pages/LiveSession";
import Notepad from "./pages/Notepad";
import Playground from "./pages/Playground";
import QueryDetails from "./pages/QueryDetail";
import ResetPassword from "./pages/ResetPassword";
import Responsive from "./pages/Responsive";
import SetNewPassword from "./pages/SetNewPassword";
import SideBarQueries from "./pages/SideBarQueries";
import Signup from "./pages/Signup";
import TaskList from "./pages/TaskList";
import TermsServices from "./pages/TermsServices";
import TestScreen from "./pages/TestScreen";
import VerifyEmail from "./pages/VerifyEmail";
import VerifyOtp from "./pages/VerifyOtp";
import ViewAllPrograms from "./pages/ViewAllPrograms";
import DashboardHome from "./pages/DashboardHome";
import TaskPage from "pages/task/TaskPage";
import ProgramDetail from "pages/program-detail/ProgramDetail";
import Help from "pages/help/Help";
import LandingPage from "pages/LandingPage";
import ErrorPage from "pages/ErrorPage";

import HelpHome from "pages/help/HelpHome";
import ViliyoTutorials from "pages/help/ViliyoTutorials";
import About from "pages/About";
import SessionDetailsCard from "components/calendar/SessionDetailsCard";
// import DeviceDetection from "pages/DeviceDetection";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layouts.Guest />,
    children: [
      { index: true, element: <Login /> },
      { path: "login", element: <Login /> },
      { path: "signup", element: <Signup /> },
      { path: "forgot-password", element: <ResetPassword /> },
      { path: "verify-email", element: <VerifyEmail /> },
      { path: "verify-otp", element: <VerifyOtp /> },
      { path: "set-newpassword", element: <SetNewPassword /> },
    ],
  },
  {
    path: "/",
    element: <Layouts.Default />,
    children: [
      { path: 'uniqueLink', element: <LandingPage /> },
      { path: 'inviteLink', element: <LandingPage /> },
      { path: 'programLink', element: <LandingPage /> },
      { path: 'error', element: <ErrorPage /> }
    ],
  },
  {
    path: "/",
    element: <Layouts.Session />,
    children: [
      { path: "live-session", element: <LiveSession /> },
      { path: "configuration", element: <Configuration /> },
      { path: "session-details", element: <SessionDetailsCard /> },
    ],
  },
  {
    path: "/",
    element: <Layouts.Admin />,
    children: [
      { path: "task/:taskId", element: <TaskPage /> },
      { path: "program-detail/:programId", element: <ProgramDetail /> },
      { path: "task-list", element: <TaskList /> },
      {
        path: "help",
        element: <HelpHome />,
        children: [
          { index: true, element: <Help /> },
          { path: "viliyo-tutorials", element: <ViliyoTutorials /> },
        ],
      },
      {
        path: "dashboard",
        element: <DashboardHome />,
        children: [{ index: true, element: <Dashboard /> }],
      },
      // { path: "device", element: <DeviceDetection /> },
      { path: "about", element: <About /> },
      { path: "calendar", element: <Calendar /> },
      { path: "history", element: <History /> },
      { path: "profile", element: <Profile /> },
      { path: "queries", element: <Queries /> },
      { path: "visiting-card", element: <VisitingCard /> },
      { path: "settings", element: <Settings /> },
      { path: "badge-list", element: <BadgeList /> },
      { path: "chat", element: <Chat /> },
      { path: "collected-visiting-card", element: <CollectedVisitingCard /> },

      { path: "exit-session", element: <ExitSession /> },

      { path: "notepad", element: <Notepad /> },
      { path: "playground", element: <Playground /> },
      { path: "query-details", element: <QueryDetails /> },
      { path: "responsive", element: <Responsive /> },
      { path: "sideBarQueries", element: <SideBarQueries /> },
      { path: "signup", element: <Signup /> },
      { path: "terms-services", element: <TermsServices /> },
      { path: "test-screen", element: <TestScreen /> },
      { path: "view-all-programs", element: <ViewAllPrograms /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
